import * as actionTypes from 'modules/appointmentTask/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isLoading = () => true;
const isEnding = () => false;

export default createReducer(initialState, {
  [actionTypes.POST_KEY_DEPOSIT_REQUEST]: isLoading,
  [actionTypes.POST_KEY_RETRIEVE_REQUEST]: isLoading,
  [actionTypes.POST_SUCCESS]: isEnding,
  [actionTypes.POST_FAILURE]: isEnding,
  [actionTypes.RESCHEDULE_KEY_DEPOSIT_REQUEST]: isLoading,
  [actionTypes.RESCHEDULE_KEY_RETRIEVE_REQUEST]: isLoading,
  [actionTypes.RESCHEDULE_SUCCESS]: isEnding,
  [actionTypes.RESCHEDULE_FAILURE]: isEnding,
  [actionTypes.PUT_KEY_DEPOSIT_REQUEST]: isLoading,
  [actionTypes.PUT_KEY_RETRIEVE_REQUEST]: isLoading,
  [actionTypes.PUT_SUCCESS]: isEnding,
  [actionTypes.PUT_FAILURE]: isEnding,
  [actionTypes.DELETE_KEY_DEPOSIT_REQUEST]: isLoading,
  [actionTypes.DELETE_KEY_RETRIEVE_REQUEST]: isLoading,
  [actionTypes.DELETE_SUCCESS]: isEnding,
  [actionTypes.DELETE_FAILURE]: isEnding,
});
